// 上报铸剑权限编码使用情况
const authUseCache = new Map()

// 上报铸剑数据字典编码使用情况
const lookupUseCache = new Map()

// 权限 code 使用上报 qt(提供后台分析前端使用旧权限编码的情况)
export const authReportQt = function (val) {
  try {
    const menuId = window.__ERPMODULE__.id
    const authKey = val + menuId
    if (!authUseCache.has(authKey)) {
      authUseCache.set(authKey, true)
      window.aplus_queue && window.aplus_queue.push({
        'action': 'aplus.record',
        'arguments': ['erp_common_auth_use_data', 'OTHER', {
          authCode: val,
          menuID: menuId
        }]
      })
    }
  } catch (error) {
    console.error('【ERP-auth-report】', error)
  }
}

// 数据字典使用情况上报（提供后台分析前端使用数据字典的情况）
export const lookUpReportQt = function (val) {
  try {
    const menuId = window.__ERPMODULE__.id
    const lookupCodeKey = val + menuId
    if (!lookupUseCache.has(lookupCodeKey)) {
      // console.log('数据字典上报:', val)
      lookupUseCache.set(lookupCodeKey, true)
      window.aplus_queue && window.aplus_queue.push({
        'action': 'aplus.record',
        'arguments': ['erp_common_lookup_use_data', 'OTHER', {
          lookupCode: val,
          menuID: menuId
        }]
      })
    }
  } catch (error) {
    console.error('【ERP-lookup-report】', error)
  }
}



// WEBPACK FOOTER //
// ./src/public/utils/qt-report.js